<div class="mds-layout">
  <mc-top-bar product="MGF SSO Admin" productshort="SSO Admin">
    <a slot="link" routerLink="/" routerLinkActive="active">Dashboard</a>
    <app-avatar-dropdown slot="actions"></app-avatar-dropdown>
  </mc-top-bar>
  <mc-side-bar>
    <nav class="mds-tree-nav" role="navigation" aria-label="side navigation">
      <ul>
        <li>
          <a routerLink="/"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: true }"
             #homeLink="routerLinkActive"
             [attr.aria-current]="homeLink.isActive ? 'page' : null">
             <mc-icon icon="layout-2x2"></mc-icon>Dashboard</a>
        </li>
        <li>
          <a routerLink="/clients"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: false }"
             #clientsSearchLink="routerLinkActive"
             [attr.aria-current]="clientsSearchLink.isActive ? 'page' : null">
             <mc-icon icon="robot"></mc-icon>Clients</a>
        </li>
        <li>
          <a routerLink="/tenants"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: false }"
             #tenantsSearchLink="routerLinkActive"
             [attr.aria-current]="tenantsSearchLink.isActive ? 'page' : null">
             <mc-icon icon="boxes-stacked"></mc-icon>Tenants</a>
        </li>
        <li>
          <a routerLink="/authorization-requests"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: false }"
             #authorizationRequestsLink="routerLinkActive"
             [attr.aria-current]="authorizationRequestsLink.isActive ? 'page' : null">
             <mc-icon icon="user-key"></mc-icon>Authorization requests</a>
        </li>
      </ul>
    </nav>
  </mc-side-bar>
  <router-outlet />
</div>
